<div class="container my-5 px-3 px-md-5" *ngIf="offering && downloads">
    <div class="row mb-2 align-items-center">
        <div class="col-xs-4 col-md-1">
            <span>
              <app-platform-icon [platform]="platform" [size]="3"></app-platform-icon>
            </span>
        </div>
        <div class="col-xs-8 col-md-11">
            <div class="h2 mt-4 mt-md-0 mb-0">{{platformName}}</div>
        </div>
    </div>
    <div class="row">
        <div class="offset-md-1 col-md-2">
            <span class="h4">Downloads</span>
        </div>
        <div class="col-md-9">
            <div class="row text-break mt-1 mb-1" *ngFor="let download of downloads">
                <div class="col-12">
                    <app-download [download]="download"></app-download>
                </div>
            </div>
        </div>
    </div>
</div>
